import { CardProductAssets } from '../types';

export const getCardImage = (assets: CardProductAssets[], name: string): string =>
  assets?.find(product => product.name === name)?.path!;
